export const createReactPageRegistry = () => {
  const pageComponentsRules = []

  function register (id, PageComponent) {
    registerByRule((pageProps) => getUniformPageId(pageProps) === id, PageComponent)
  }

  function registerByRule(ruleFunction, PageComponent) {
    pageComponentsRules.push({rule: ruleFunction, component: PageComponent})
  }

  function isPageRegistered (pageProps) {
    return pageComponentsRules.some(rule => rule.rule(pageProps))
  }

  function getComponentFor (pageProps) {
    const component = pageComponentsRules.find(({ rule }) => rule(pageProps))?.component

    if (component) {
      return component
    }

    return null
  }

  function getUniformPageId (pageProps) {
    return pageProps?.page?.id
  }
  return { register, registerByRule, isPageRegistered, getComponentFor }
}
